export const LANGUAGE_KEYS = [
  { label: "English", value: 1 },
  { label: "Hebrew", value: 2 },
]
